
import { useParams, Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';

interface CountryDetail {
  name: string;
  slug: string;
  flag: string;
  type: string;
  image: string;
  description: string;
  visaInfo: {
    intro: string;
    requirements: string[];
    process: string[];
    duration: string;
    fee: string;
    validity: string;
  };
  sections: Array<{
    title: string;
    content: string;
  }>;
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

const countriesData: Record<string, CountryDetail> = {
  'ispanya': {
    name: 'İspanya',
    slug: 'ispanya',
    flag: '🇪🇸',
    type: 'Schengen',
    image: 'https://public.readdy.ai/ai/img_res/ca5e46cc7fc9ee785c2580c969aeff76.jpg',
    description: 'İspanya Schengen vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'İspanya, Schengen Bölgesi\'nin en popüler turistik destinasyonlarından biridir. Barcelona, Madrid, Sevilla gibi şehirleri, plajları ve zengin kültürel mirası ile her yıl milyonlarca turisti ağırlamaktadır. İzmir Vize Danışmanlık olarak İspanya vize başvurularınızda profesyonel destek sunuyoruz.',
      requirements: [
        'Geçerli pasaport (en az 6 ay süreli)',
        'Vize başvuru formu (eksiksiz doldurulmuş)',
        'Biyometrik fotoğraf (son 6 ay içinde çekilmiş)',
        'Seyahat sağlık sigortası (minimum 30.000 Euro)',
        'Uçak rezervasyonu (gidiş-dönüş)',
        'Otel rezervasyonu veya konaklama belgesi',
        'Banka hesap özeti (son 3 ay)',
        'İş yerinden izin belgesi veya öğrenci belgesi',
        'Seyahat planı ve güzergah'
      ],
      process: [
        'Ön değerlendirme ve danışmanlık',
        'Evrakların hazırlanması',
        'BLS Spain randevu alınması',
        'Başvuru dosyasının kontrolü',
        'Biyometrik veri kaydı',
        'Başvuru takibi',
        'Vize sonucu ve pasaport teslimi'
      ],
      duration: '15-20 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'İspanya Vizesi Hakkında',
        content: 'İspanya Schengen vizesi, 27 Schengen ülkesine seyahat imkanı sağlar. Turistik, ticari veya aile ziyareti amaçlı başvuru yapabilirsiniz. İspanya, özellikle yaz aylarında plaj tatili, kültür turu ve gastronomi deneyimi için tercih edilmektedir.'
      },
      {
        title: 'İspanya Vize Başvuru Süreci',
        content: 'İspanya vize başvuruları İzmir\'de BLS Spain aracılığıyla yapılmaktadır. Randevu alınması, evrakların hazırlanması ve başvuru sürecinin takibi profesyonel destek gerektirir. İzmir Vize Danışmanlık olarak tüm süreci sizin adınıza yönetiyoruz.'
      },
      {
        title: 'İspanya\'da Gezilecek Yerler',
        content: 'Barcelona\'da Sagrada Familia, Park Güell; Madrid\'de Prado Müzesi, Kraliyet Sarayı; Sevilla\'da Alcazar Sarayı, Giralda Kulesi; Granada\'da Elhamra Sarayı; Valencia\'da Sanat ve Bilim Şehri gibi dünyaca ünlü turistik mekanları ziyaret edebilirsiniz.'
      }
    ],
    faqs: [
      {
        question: 'İspanya vizesi kaç günde çıkar?',
        answer: 'İspanya vize başvuruları ortalama 15-20 iş günü içinde sonuçlanır. Yoğun dönemlerde bu süre uzayabilir.'
      },
      {
        question: 'İspanya vizesi için hesapta ne kadar para olmalı?',
        answer: 'Günlük minimum 70-90 Euro gösterebilmeniz beklenir. 15 günlük seyahat için yaklaşık 1000-1500 Euro banka bakiyesi önerilir.'
      },
      {
        question: 'İspanya vizesi ile hangi ülkelere gidebilirim?',
        answer: 'İspanya Schengen vizesi ile 27 Schengen ülkesine seyahat edebilirsiniz: Fransa, Almanya, İtalya, Hollanda ve diğerleri.'
      }
    ]
  },
  'fransa': {
    name: 'Fransa',
    slug: 'fransa',
    flag: '🇫🇷',
    type: 'Schengen',
    image: 'https://readdy.ai/api/search-image?query=eiffel%20tower%20paris%20france%20iconic%20landmark%20golden%20sunset%20romantic%20city%20beautiful%20architecture%20seine%20river%20view%20tourist%20destination%20panoramic%20cityscape&width=1200&height=600&seq=france-detail-hero-002&orientation=landscape',
    description: 'Fransa Schengen vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'Fransa, dünyanın en çok ziyaret edilen ülkesidir. Paris\'in romantik atmosferi, Provence\'ın lavanta tarlaları, Côte d\'Azur\'un plajları ve zengin mutfak kültürü ile her yıl 90 milyondan fazla turisti ağırlamaktadır.',
      requirements: [
        'Geçerli pasaport (en az 6 ay süreli)',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sağlık sigortası',
        'Uçak ve otel rezervasyonu',
        'Mali durum belgeleri',
        'İş veya öğrenci belgesi',
        'Seyahat planı'
      ],
      process: [
        'Ön değerlendirme',
        'Evrak hazırlığı',
        'TLScontact randevusu',
        'Başvuru ve biyometrik kayıt',
        'Süreç takibi',
        'Vize teslimi'
      ],
      duration: '15-20 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'Fransa Vizesi Hakkında',
        content: 'Fransa Schengen vizesi, Avrupa\'nın kapılarını açar. Turistik, ticari, eğitim veya aile ziyareti amaçlı başvuru yapabilirsiniz. Fransa, sanat, moda, gastronomi ve tarih meraklıları için vazgeçilmez bir destinasyondur.'
      },
      {
        title: 'Fransa Vize Başvuru Süreci',
        content: 'Fransa vize başvuruları İzmir\'de TLScontact aracılığıyla yapılmaktadır. Online randevu sistemi, evrak yükleme ve biyometrik veri kaydı sürecin temel adımlarıdır. Profesyonel danışmanlık ile sürecinizi kolaylaştırıyoruz.'
      },
      {
        title: 'Fransa\'da Gezilecek Yerler',
        content: 'Paris\'te Eyfel Kulesi, Louvre Müzesi, Notre-Dame; Provence\'da lavanta tarlaları; Nice ve Cannes\'da Akdeniz plajları; Loire Vadisi\'nde şatolar; Bordeaux\'da şarap bağları; Mont Saint-Michel\'de ortaçağ manastırı ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'Fransa vizesi kaç günde çıkar?',
        answer: 'Fransa vize başvuruları ortalama 15-20 iş günü içinde sonuçlanır.'
      },
      {
        question: 'Fransa vizesi için ne kadar para gerekli?',
        answer: 'Günlük 80-100 Euro gösterebilmeniz önerilir. Konaklama ve ulaşım masraflarını karşılayacak yeterli bakiye gereklidir.'
      },
      {
        question: 'Fransa vizesi zor mu?',
        answer: 'Doğru evrak hazırlığı ve profesyonel danışmanlık ile Fransa vizesi almak mümkündür. Başarı oranımız %98\'dir.'
      }
    ]
  },
  'almanya': {
    name: 'Almanya',
    slug: 'almanya',
    flag: '🇩🇪',
    type: 'Schengen',
    image: 'https://readdy.ai/api/search-image?query=brandenburg%20gate%20berlin%20germany%20historic%20landmark%20blue%20sky%20iconic%20neoclassical%20architecture%20tourist%20destination%20famous%20monument%20panoramic%20view&width=1200&height=600&seq=germany-detail-hero-003&orientation=landscape',
    description: 'Almanya Schengen vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'Almanya, Avrupa\'nın ekonomik ve kültürel merkezi olarak öne çıkmaktadır. Berlin\'in tarihi, Münih\'in gelenekleri, Frankfurt\'un iş dünyası ve Bavyera\'nın doğal güzellikleri ile çeşitli seyahat amaçlarına hitap etmektedir.',
      requirements: [
        'Geçerli pasaport',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sigortası',
        'Uçak ve konaklama rezervasyonu',
        'Finansal belgeler',
        'İş/öğrenci belgesi',
        'Davetiye (varsa)'
      ],
      process: [
        'Danışmanlık görüşmesi',
        'Evrak hazırlığı',
        'iDATA randevusu',
        'Başvuru teslimi',
        'Süreç takibi',
        'Vize alımı'
      ],
      duration: '10-15 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'Almanya Vizesi Hakkında',
        content: 'Almanya Schengen vizesi, iş, turizm, eğitim ve aile ziyareti amaçlı düzenlenmektedir. Almanya, özellikle fuar ziyaretleri, iş görüşmeleri ve üniversite eğitimi için tercih edilmektedir.'
      },
      {
        title: 'Almanya Vize Başvuru Süreci',
        content: 'Almanya vize başvuruları İzmir\'de iDATA aracılığıyla yapılmaktadır. Almanya konsolosluğu evrak kontrolünde titiz davranmaktadır. Profesyonel evrak hazırlığı başarı şansını artırır.'
      },
      {
        title: 'Almanya\'da Gezilecek Yerler',
        content: 'Berlin\'de Brandenburg Kapısı, Berlin Duvarı; Münih\'te Marienplatz, Neuschwanstein Şatosu; Frankfurt\'ta Römerberg; Köln\'de Köln Katedrali; Heidelberg\'de tarihi şato ve üniversite; Kara Orman bölgesinde doğa yürüyüşleri yapılabilir.'
      }
    ],
    faqs: [
      {
        question: 'Almanya vizesi kaç günde çıkar?',
        answer: 'Almanya vize başvuruları ortalama 10-15 iş günü içinde sonuçlanır.'
      },
      {
        question: 'Almanya vizesi için hesapta ne kadar para olmalı?',
        answer: 'Günlük 60-80 Euro gösterebilmeniz beklenir. Seyahat süresine göre yeterli bakiye gereklidir.'
      },
      {
        question: 'Almanya iş vizesi nasıl alınır?',
        answer: 'İş vizesi için davetiye mektubu, şirket bilgileri ve seyahat amacını kanıtlayan belgeler gereklidir.'
      }
    ]
  },
  'ingiltere': {
    name: 'İngiltere',
    slug: 'ingiltere',
    flag: '🇬🇧',
    type: 'Ulusal Vize',
    image: 'https://readdy.ai/api/search-image?query=big%20ben%20tower%20bridge%20london%20england%20iconic%20clock%20tower%20thames%20river%20historic%20landmark%20tourist%20destination%20beautiful%20architecture%20panoramic%20cityscape&width=1200&height=600&seq=uk-detail-hero-004&orientation=landscape',
    description: 'İngiltere vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'İngiltere, Brexit sonrası Schengen\'den bağımsız vize sistemi uygulamaktadır. Londra\'nın kozmopolit yapısı, tarihi mekanları, üniversiteleri ve iş fırsatları ile farklı amaçlarla ziyaret edilmektedir.',
      requirements: [
        'Geçerli pasaport',
        'Online başvuru formu',
        'Biyometrik fotoğraf',
        'Mali durum belgeleri',
        'Konaklama kanıtı',
        'Seyahat planı',
        'İş/öğrenci belgesi',
        'Sponsorluk mektubu (varsa)'
      ],
      process: [
        'Online başvuru',
        'Evrak hazırlığı',
        'VFS Global randevusu',
        'Biyometrik kayıt',
        'Evrak teslimi',
        'Süreç takibi',
        'Vize sonucu'
      ],
      duration: '15-21 iş günü',
      fee: '115 GBP + hizmet bedeli',
      validity: '6 ay - 10 yıl (multiple entry)'
    },
    sections: [
      {
        title: 'İngiltere Vizesi Hakkında',
        content: 'İngiltere Standard Visitor Visa, turistik, ticari ve aile ziyareti amaçlı düzenlenmektedir. Brexit sonrası İngiltere vizesi Schengen vizesinden bağımsızdır ve ayrı başvuru gerektirir.'
      },
      {
        title: 'İngiltere Vize Başvuru Süreci',
        content: 'İngiltere vize başvuruları tamamen online yapılır. VFS Global\'de biyometrik veri kaydı ve evrak teslimi gerçekleştirilir. Priority ve Super Priority hizmetleri ile süreç hızlandırılabilir.'
      },
      {
        title: 'İngiltere\'de Gezilecek Yerler',
        content: 'Londra\'da Big Ben, Tower Bridge, Buckingham Sarayı, British Museum; Edinburgh\'da tarihi kale; Oxford ve Cambridge\'de üniversiteler; Stonehenge\'de tarih öncesi anıt; Lake District\'te doğa yürüyüşleri yapılabilir.'
      }
    ],
    faqs: [
      {
        question: 'İngiltere vizesi kaç günde çıkar?',
        answer: 'Standard başvurular 15-21 iş günü, Priority 5 iş günü, Super Priority 24 saat içinde sonuçlanır.'
      },
      {
        question: 'İngiltere vizesi ücreti ne kadar?',
        answer: 'Standard Visitor Visa ücreti 115 GBP\'dir. Priority hizmetler için ek ücret ödenir.'
      },
      {
        question: 'İngiltere vizesi ile Avrupa\'ya gidebilir miyim?',
        answer: 'Hayır, İngiltere vizesi sadece Birleşik Krallık için geçerlidir. Schengen ülkeleri için ayrı vize gerekir.'
      }
    ]
  },
  'yunanistan': {
    name: 'Yunanistan',
    slug: 'yunanistan',
    flag: '🇬🇷',
    type: 'Schengen',
    image: 'https://readdy.ai/api/search-image?query=santorini%20greece%20white%20buildings%20blue%20domes%20aegean%20sea%20beautiful%20island%20scenic%20view%20sunset%20caldera%20romantic%20destination%20panoramic%20mediterranean&width=1200&height=600&seq=greece-detail-hero-005&orientation=landscape',
    description: 'Yunanistan Schengen vizesi için İzmir\'den Kosmos Vize desteği',
    visaInfo: {
      intro: 'Yunanistan, antik tarihi, muhteşem adaları ve Akdeniz mutfağı ile öne çıkmaktadır. Santorini, Mykonos, Atina ve Selanik gibi destinasyonlar her yıl milyonlarca turisti ağırlamaktadır.',
      requirements: [
        'Geçerli pasaport',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sigortası',
        'Uçak ve otel rezervasyonu',
        'Banka hesap özeti',
        'İş belgesi',
        'Seyahat planı'
      ],
      process: [
        'Ön değerlendirme',
        'Evrak hazırlığı',
        'Kosmos Vize randevusu',
        'Başvuru teslimi',
        'Biyometrik kayıt',
        'Süreç takibi',
        'Vize alımı'
      ],
      duration: '10-15 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'Yunanistan Vizesi Hakkında',
        content: 'Yunanistan Schengen vizesi, İzmir\'den en kolay ulaşılabilir Schengen ülkelerinden biri için düzenlenmektedir. Turistik, ticari ve aile ziyareti amaçlı başvuru yapılabilir.'
      },
      {
        title: 'Yunanistan Vize Başvuru Süreci',
        content: 'Yunanistan vize başvuruları İzmir\'de Kosmos Vize aracılığıyla yapılmaktadır. Randevu planlaması, evrak hazırlığı ve başvuru süreci profesyonel destek ile kolaylaşır.'
      },
      {
        title: 'Yunanistan\'da Gezilecek Yerler',
        content: 'Atina\'da Akropolis, Parthenon; Santorini\'de gün batımı manzaraları; Mykonos\'ta plajlar ve gece hayatı; Selanik\'te Beyaz Kule; Rodos\'ta ortaçağ şehri; Girit\'te Knossos Sarayı ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'Yunanistan vizesi kaç günde çıkar?',
        answer: 'Yunanistan vize başvuruları ortalama 10-15 iş günü içinde sonuçlanır.'
      },
      {
        question: 'Yunanistan vizesi kolay mı?',
        answer: 'Doğru evrak hazırlığı ile Yunanistan vizesi almak mümkündür. İzmir\'den coğrafi yakınlık avantaj sağlar.'
      },
      {
        question: 'Yunanistan vizesi ile adalara gidebilir miyim?',
        answer: 'Evet, Yunanistan Schengen vizesi ile tüm Yunan adalarına seyahat edebilirsiniz.'
      }
    ]
  },
  'hollanda': {
    name: 'Hollanda',
    slug: 'hollanda',
    flag: '🇳🇱',
    type: 'Schengen',
    image: 'https://readdy.ai/api/search-image?query=amsterdam%20canal%20houses%20netherlands%20colorful%20buildings%20water%20reflections%20dutch%20architecture%20historic%20windmills%20tulips%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=netherlands-detail-hero-006&orientation=landscape',
    description: 'Hollanda Schengen vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'Hollanda, kanalları, bisiklet kültürü, lale tarlaları ve müzeleri ile tanınmaktadır. Amsterdam, Rotterdam, Den Haag ve Utrecht gibi şehirleri farklı deneyimler sunmaktadır.',
      requirements: [
        'Geçerli pasaport',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sigortası',
        'Uçak ve otel rezervasyonu',
        'Mali durum belgeleri',
        'İş belgesi',
        'Davetiye (varsa)'
      ],
      process: [
        'Danışmanlık',
        'Evrak hazırlığı',
        'VFS Global randevusu',
        'Başvuru teslimi',
        'Süreç takibi',
        'Vize alımı'
      ],
      duration: '15-20 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'Hollanda Vizesi Hakkında',
        content: 'Hollanda Schengen vizesi, turistik, ticari ve aile ziyareti amaçlı düzenlenmektedir. Hollanda, özellikle lale sezonu, müze ziyaretleri ve iş fuarları için tercih edilmektedir.'
      },
      {
        title: 'Hollanda Vize Başvuru Süreci',
        content: 'Hollanda vize başvuruları VFS Global aracılığıyla yapılmaktadır. Davetiye mektubu ve seyahat planı kontrolü önemlidir.'
      },
      {
        title: 'Hollanda\'da Gezilecek Yerler',
        content: 'Amsterdam\'da Anne Frank Evi, Van Gogh Müzesi, Rijksmuseum; Keukenhof\'ta lale bahçeleri; Rotterdam\'da modern mimari; Zaanse Schans\'ta yel değirmenleri; Giethoorn\'da kanal köyü ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'Hollanda vizesi kaç günde çıkar?',
        answer: 'Hollanda vize başvuruları ortalama 15-20 iş günü içinde sonuçlanır.'
      },
      {
        question: 'Hollanda vizesi için davetiye gerekli mi?',
        answer: 'Aile ziyareti için davetiye gereklidir. Turistik seyahat için otel rezervasyonu yeterlidir.'
      },
      {
        question: 'Hollanda vizesi ile Belçika\'ya gidebilir miyim?',
        answer: 'Evet, Hollanda Schengen vizesi ile tüm Schengen ülkelerine seyahat edebilirsiniz.'
      }
    ]
  },
  'italya': {
    name: 'İtalya',
    slug: 'italya',
    flag: '🇮🇹',
    type: 'Schengen',
    image: 'https://readdy.ai/api/search-image?query=colosseum%20rome%20italy%20ancient%20amphitheater%20historic%20landmark%20blue%20sky%20iconic%20architecture%20tourist%20destination%20roman%20empire%20panoramic%20view&width=1200&height=600&seq=italy-detail-hero-007&orientation=landscape',
    description: 'İtalya Schengen vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'İtalya, sanat, tarih, moda ve gastronomi ile dünyanın en çok ziyaret edilen ülkelerinden biridir. Roma, Venedik, Floransa, Milano ve Napoli farklı deneyimler sunmaktadır.',
      requirements: [
        'Geçerli pasaport',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sigortası',
        'Uçak ve otel rezervasyonu',
        'Banka hesap özeti',
        'İş belgesi',
        'Seyahat planı'
      ],
      process: [
        'Ön değerlendirme',
        'Evrak hazırlığı',
        'VFS Global randevusu',
        'Başvuru teslimi',
        'Süreç takibi',
        'Vize alımı'
      ],
      duration: '15-20 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'İtalya Vizesi Hakkında',
        content: 'İtalya Schengen vizesi, turistik, ticari ve aile ziyareti amaçlı düzenlenmektedir. İtalya, sanat eserleri, tarihi mekanlar ve İtalyan mutfağı için vazgeçilmez bir destinasyondur.'
      },
      {
        title: 'İtalya Vize Başvuru Süreci',
        content: 'İtalya vize başvuruları VFS Global aracılığıyla yapılmaktadır. Detaylı seyahat planı ve konaklama belgesi önemlidir.'
      },
      {
        title: 'İtalya\'da Gezilecek Yerler',
        content: 'Roma\'da Kolezyum, Vatikan, Trevi Çeşmesi; Venedik\'te San Marco Meydanı, gondol turu; Floransa\'da Uffizi Galerisi, Duomo; Milano\'da moda bölgesi, La Scala; Amalfi Sahili\'nde muhteşem manzaralar ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'İtalya vizesi kaç günde çıkar?',
        answer: 'İtalya vize başvuruları ortalama 15-20 iş günü içinde sonuçlanır.'
      },
      {
        question: 'İtalya vizesi için ne kadar para gerekli?',
        answer: 'Günlük 70-90 Euro gösterebilmeniz önerilir. Konaklama ve ulaşım masraflarını karşılayacak bakiye gereklidir.'
      },
      {
        question: 'İtalya vizesi zor mu?',
        answer: 'Doğru evrak hazırlığı ile İtalya vizesi almak mümkündür. Profesyonel danışmanlık başarı şansını artırır.'
      }
    ]
  },
  'amerika': {
    name: 'Amerika',
    slug: 'amerika',
    flag: '🇺🇸',
    type: 'Ulusal Vize',
    image: 'https://readdy.ai/api/search-image?query=statue%20of%20liberty%20new%20york%20usa%20iconic%20landmark%20blue%20sky%20american%20symbol%20freedom%20manhattan%20skyline%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=usa-detail-hero-008&orientation=landscape',
    description: 'Amerika vizesi için İzmir\'den profesyonel danışmanlık ve mülakat hazırlığı',
    visaInfo: {
      intro: 'Amerika Birleşik Devletleri, dünyanın en çok ziyaret edilen ülkelerinden biridir. New York, Los Angeles, Miami, Las Vegas ve San Francisco gibi şehirleri farklı deneyimler sunmaktadır.',
      requirements: [
        'Geçerli pasaport',
        'DS-160 form onay sayfası',
        'Vize ücreti makbuzu',
        'Mülakat randevu onayı',
        'Biyometrik fotoğraf (5x5 cm)',
        'Mali durum belgeleri',
        'İş/öğrenci belgesi',
        'Seyahat planı'
      ],
      process: [
        'Profil değerlendirmesi',
        'DS-160 form doldurma',
        'Vize ücreti ödeme',
        'Mülakat randevusu',
        'Evrak hazırlığı',
        'Mülakat simülasyonu',
        'Konsolosluk mülakatı',
        'Vize sonucu'
      ],
      duration: '3-10 iş günü (mülakat sonrası)',
      fee: '185 USD + hizmet bedeli',
      validity: '10 yıl (multiple entry)'
    },
    sections: [
      {
        title: 'Amerika Vizesi Hakkında',
        content: 'Amerika B1/B2 vizesi, turistik ve ticari amaçlı seyahatler için düzenlenmektedir. Mülakat süreci, Amerika vize başvurusunun en kritik aşamasıdır. Profesyonel hazırlık başarı şansını artırır.'
      },
      {
        title: 'Amerika Vize Mülakat Süreci',
        content: 'Amerika vize mülakatı, Ankara veya İstanbul\'daki ABD Büyükelçiliği/Başkonsolosluğu\'nda gerçekleşir. Mülakat sırasında seyahat amacı, mali durum ve geri dönüş niyeti değerlendirilir.'
      },
      {
        title: 'Amerika\'da Gezilecek Yerler',
        content: 'New York\'ta Özgürlük Heykeli, Times Square, Central Park; Los Angeles\'ta Hollywood, Santa Monica; Las Vegas\'ta kumarhaneler; San Francisco\'da Golden Gate Köprüsü; Miami\'de plajlar; Grand Canyon\'da doğa harikası ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'Amerika vizesi kaç günde çıkar?',
        answer: 'Mülakat sonrası vize işlemi 3-10 iş günü içinde tamamlanır. Ek inceleme gerekirse 2-8 hafta sürebilir.'
      },
      {
        question: 'Amerika vizesi için hesapta ne kadar para olmalı?',
        answer: 'Kesin miktar yoktur, ancak 5.000-10.000 USD veya üzeri bakiye olumlu değerlendirilir.'
      },
      {
        question: 'Amerika vizesi reddedilirse ne yapmalıyım?',
        answer: 'Ret nedeni analiz edilmeli, eksiklikler giderilmeli ve yeniden başvuru yapılmalıdır. Profesyonel danışmanlık önerilir.'
      }
    ]
  },
  'bulgaristan': {
    name: 'Bulgaristan',
    slug: 'bulgaristan',
    flag: '🇧🇬',
    type: 'Ulusal Vize',
    image: 'https://readdy.ai/api/search-image?query=rila%20monastery%20bulgaria%20orthodox%20church%20mountains%20colorful%20frescoes%20historic%20religious%20architecture%20unesco%20world%20heritage%20site%20panoramic%20view&width=1200&height=600&seq=bulgaria-detail-hero-009&orientation=landscape',
    description: 'Bulgaristan vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'Bulgaristan, Türkiye\'ye komşu bir ülke olarak kolay ulaşım imkanı sunmaktadır. Sofya, Plovdiv, Varna ve Burgas gibi şehirleri tarihi ve doğal güzellikleri ile dikkat çekmektedir.',
      requirements: [
        'Geçerli pasaport',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sigortası',
        'Uçak/otobüs rezervasyonu',
        'Otel rezervasyonu',
        'Mali durum belgeleri',
        'İş belgesi'
      ],
      process: [
        'Ön değerlendirme',
        'Evrak hazırlığı',
        'Konsolosluk randevusu',
        'Başvuru teslimi',
        'Süreç takibi',
        'Vize alımı'
      ],
      duration: '10-15 iş günü',
      fee: '60 Euro + hizmet bedeli',
      validity: '90 gün'
    },
    sections: [
      {
        title: 'Bulgaristan Vizesi Hakkında',
        content: 'Bulgaristan henüz Schengen Bölgesi\'ne tam üye olmadığından ulusal vize uygulamaktadır. Turistik, ticari ve transit amaçlı başvuru yapılabilir.'
      },
      {
        title: 'Bulgaristan Vize Başvuru Süreci',
        content: 'Bulgaristan vize başvuruları İzmir\'deki Bulgaristan Konsolosluğu aracılığıyla yapılmaktadır. Randevu ve evrak süreci profesyonel destek ile kolaylaşır.'
      },
      {
        title: 'Bulgaristan\'da Gezilecek Yerler',
        content: 'Sofya\'da Alexander Nevsky Katedrali, Vitosha Dağı; Plovdiv\'de antik tiyatro, eski şehir; Rila Manastırı\'nda UNESCO mirası; Varna\'da Karadeniz plajları; Bansko\'da kayak merkezi ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'Bulgaristan vizesi kaç günde çıkar?',
        answer: 'Bulgaristan vize başvuruları ortalama 10-15 iş günü içinde sonuçlanır.'
      },
      {
        question: 'Bulgaristan vizesi ile Schengen\'e gidebilir miyim?',
        answer: 'Hayır, Bulgaristan vizesi sadece Bulgaristan için geçerlidir. Schengen ülkeleri için ayrı vize gerekir.'
      },
      {
        question: 'Bulgaristan vizesi kolay mı?',
        answer: 'Türkiye\'ye komşu olması nedeniyle Bulgaristan vizesi nispeten kolay alınabilmektedir.'
      }
    ]
  },
  'isvicre': {
    name: 'İsviçre',
    slug: 'isvicre',
    flag: '🇨🇭',
    type: 'Schengen',
    image: 'https://readdy.ai/api/search-image?query=matterhorn%20switzerland%20alps%20mountain%20peak%20snow%20scenic%20landscape%20majestic%20nature%20zermatt%20ski%20resort%20beautiful%20panorama%20swiss%20alps&width=1200&height=600&seq=switzerland-detail-hero-010&orientation=landscape',
    description: 'İsviçre Schengen vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'İsviçre, Alp Dağları, gölleri, çikolatası ve saatleri ile tanınmaktadır. Zürih, Cenevre, Bern ve Lucerne gibi şehirleri lüks turizm ve iş seyahatleri için tercih edilmektedir.',
      requirements: [
        'Geçerli pasaport',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sigortası',
        'Uçak ve otel rezervasyonu',
        'Mali durum belgeleri',
        'İş belgesi',
        'Seyahat planı'
      ],
      process: [
        'Danışmanlık',
        'Evrak hazırlığı',
        'VFS Global randevusu',
        'Başvuru teslimi',
        'Süreç takibi',
        'Vize alımı'
      ],
      duration: '15-20 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'İsviçre Vizesi Hakkında',
        content: 'İsviçre Schengen vizesi, turistik, ticari ve aile ziyareti amaçlı düzenlenmektedir. İsviçre, özellikle kayak tatili, iş toplantıları ve lüks alışveriş için tercih edilmektedir.'
      },
      {
        title: 'İsviçre Vize Başvuru Süreci',
        content: 'İsviçre vize başvuruları VFS Global aracılığıyla yapılmaktadır. Mali yeterlilik ve seyahat planı detaylı incelenmektedir.'
      },
      {
        title: 'İsviçre\'de Gezilecek Yerler',
        content: 'Zürih\'te eski şehir, göl kıyısı; Cenevre\'de BM merkezi, jet d\'eau; Lucerne\'de Kapellbrücke, Pilatus Dağı; Interlaken\'de Jungfrau; Zermatt\'ta Matterhorn; Montreux\'de Chillon Şatosu ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'İsviçre vizesi kaç günde çıkar?',
        answer: 'İsviçre vize başvuruları ortalama 15-20 iş günü içinde sonuçlanır.'
      },
      {
        question: 'İsviçre vizesi için ne kadar para gerekli?',
        answer: 'İsviçre pahalı bir ülke olduğundan günlük 100-150 Euro gösterebilmeniz önerilir.'
      },
      {
        question: 'İsviçre vizesi zor mu?',
        answer: 'Güçlü mali durum ve doğru evrak hazırlığı ile İsviçre vizesi almak mümkündür.'
      }
    ]
  },
  'avusturya': {
    name: 'Avusturya',
    slug: 'avusturya',
    flag: '🇦🇹',
    type: 'Schengen',
    image: 'https://readdy.ai/api/search-image?query=schonbrunn%20palace%20vienna%20austria%20baroque%20architecture%20beautiful%20gardens%20historic%20imperial%20residence%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=austria-detail-hero-011&orientation=landscape',
    description: 'Avusturya Schengen vizesi için İzmir\'den profesyonel danışmanlık hizmeti',
    visaInfo: {
      intro: 'Avusturya, klasik müzik, imparatorluk mirası ve Alp manzaraları ile tanınmaktadır. Viyana, Salzburg, Innsbruck ve Hallstatt farklı deneyimler sunmaktadır.',
      requirements: [
        'Geçerli pasaport',
        'Vize başvuru formu',
        'Biyometrik fotoğraf',
        'Seyahat sigortası',
        'Uçak ve otel rezervasyonu',
        'Mali durum belgeleri',
        'İş belgesi',
        'Seyahat planı'
      ],
      process: [
        'Ön değerlendirme',
        'Evrak hazırlığı',
        'VFS Global randevusu',
        'Başvuru teslimi',
        'Süreç takibi',
        'Vize alımı'
      ],
      duration: '15-20 iş günü',
      fee: '80 Euro + hizmet bedeli',
      validity: '90 gün (180 gün içinde)'
    },
    sections: [
      {
        title: 'Avusturya Vizesi Hakkında',
        content: 'Avusturya Schengen vizesi, turistik, ticari ve aile ziyareti amaçlı düzenlenmektedir. Avusturya, özellikle kültür turu, kayak tatili ve müzik festivalleri için tercih edilmektedir.'
      },
      {
        title: 'Avusturya Vize Başvuru Süreci',
        content: 'Avusturya vize başvuruları VFS Global aracılığıyla yapılmaktadır. Detaylı seyahat planı ve konaklama belgesi önemlidir.'
      },
      {
        title: 'Avusturya\'da Gezilecek Yerler',
        content: 'Viyana\'da Schönbrunn Sarayı, Stephansdom, Opera; Salzburg\'da Mozart\'ın evi, Hohensalzburg Kalesi; Innsbruck\'ta Alp manzaraları; Hallstatt\'ta göl köyü; Wachau Vadisi\'nde şarap bağları ziyaret edilebilir.'
      }
    ],
    faqs: [
      {
        question: 'Avusturya vizesi kaç günde çıkar?',
        answer: 'Avusturya vize başvuruları ortalama 15-20 iş günü içinde sonuçlanır.'
      },
      {
        question: 'Avusturya vizesi için ne kadar para gerekli?',
        answer: 'Günlük 70-90 Euro gösterebilmeniz önerilir.'
      },
      {
        question: 'Avusturya vizesi ile Almanya\'ya gidebilir miyim?',
        answer: 'Evet, Avusturya Schengen vizesi ile tüm Schengen ülkelerine seyahat edebilirsiniz.'
      }
    ]
  }
};

// Diğer ülkeler için varsayılan veri oluştur
const defaultCountryData = (name: string, slug: string, flag: string, type: string, image: string): CountryDetail => ({
  name,
  slug,
  flag,
  type,
  image,
  description: `${name} vizesi için İzmir'den profesyonel danışmanlık hizmeti`,
  visaInfo: {
    intro: `${name}, benzersiz kültürü ve turistik mekanları ile dikkat çekmektedir. İzmir Vize Danışmanlık olarak ${name} vize başvurularınızda profesyonel destek sunuyoruz.`,
    requirements: [
      'Geçerli pasaport (en az 6 ay süreli)',
      'Vize başvuru formu',
      'Biyometrik fotoğraf',
      'Seyahat sağlık sigortası',
      'Uçak ve otel rezervasyonu',
      'Mali durum belgeleri',
      'İş/öğrenci belgesi',
      'Seyahat planı'
    ],
    process: [
      'Ön değerlendirme ve danışmanlık',
      'Evrakların hazırlanması',
      'Randevu alınması',
      'Başvuru dosyasının kontrolü',
      'Başvuru teslimi',
      'Süreç takibi',
      'Vize sonucu ve pasaport teslimi'
    ],
    duration: '15-20 iş günü',
    fee: '80 Euro + hizmet bedeli',
    validity: '90 gün (180 gün içinde)'
  },
  sections: [
    {
      title: `${name} Vizesi Hakkında`,
      content: `${name} ${type} vizesi, turistik, ticari ve aile ziyareti amaçlı düzenlenmektedir. Profesyonel danışmanlık ile vize sürecinizi kolaylaştırıyoruz.`
    },
    {
      title: `${name} Vize Başvuru Süreci`,
      content: `${name} vize başvuruları profesyonel destek ile yönetilmektedir. Evrak hazırlığı, randevu alma ve başvuru takibi süreçlerinde yanınızdayız.`
    }
  ],
  faqs: [
    {
      question: `${name} vizesi kaç günde çıkar?`,
      answer: `${name} vize başvuruları ortalama 15-20 iş günü içinde sonuçlanır.`
    },
    {
      question: `${name} vizesi için ne kadar para gerekli?`,
      answer: 'Seyahat süresine göre yeterli mali güç gösterilmelidir. Detaylı bilgi için danışmanlık alabilirsiniz.'
    }
  ]
});

// Eksik ülkeleri ekle
const additionalCountries: Record<string, CountryDetail> = {
  'belcika': defaultCountryData('Belçika', 'belcika', '🇧🇪', 'Schengen', 'https://readdy.ai/api/search-image?query=grand%20place%20brussels%20belgium%20historic%20square%20ornate%20buildings%20golden%20architecture%20gothic%20baroque%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=belgium-detail-hero-012&orientation=landscape'),
  'portekiz': defaultCountryData('Portekiz', 'portekiz', '🇵🇹', 'Schengen', 'https://readdy.ai/api/search-image?query=belem%20tower%20lisbon%20portugal%20historic%20fortress%20tagus%20river%20manueline%20architecture%20tourist%20destination%20beautiful%20sunset%20panoramic%20view&width=1200&height=600&seq=portugal-detail-hero-013&orientation=landscape'),
  'isvec': defaultCountryData('İsveç', 'isvec', '🇸🇪', 'Schengen', 'https://readdy.ai/api/search-image?query=stockholm%20sweden%20gamla%20stan%20colorful%20buildings%20waterfront%20scandinavian%20architecture%20old%20town%20historic%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=sweden-detail-hero-014&orientation=landscape'),
  'norvec': defaultCountryData('Norveç', 'norvec', '🇳🇴', 'Schengen', 'https://readdy.ai/api/search-image?query=geirangerfjord%20norway%20fjord%20mountains%20water%20scenic%20nature%20dramatic%20landscape%20northern%20lights%20aurora%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=norway-detail-hero-015&orientation=landscape'),
  'danimarka': defaultCountryData('Danimarka', 'danimarka', '🇩🇰', 'Schengen', 'https://readdy.ai/api/search-image?query=nyhavn%20copenhagen%20denmark%20colorful%20houses%20canal%20boats%20scandinavian%20architecture%20tourist%20destination%20beautiful%20waterfront%20panoramic%20view&width=1200&height=600&seq=denmark-detail-hero-016&orientation=landscape'),
  'finlandiya': defaultCountryData('Finlandiya', 'finlandiya', '🇫🇮', 'Schengen', 'https://readdy.ai/api/search-image?query=helsinki%20cathedral%20finland%20white%20church%20blue%20sky%20neoclassical%20architecture%20senate%20square%20northern%20lights%20aurora%20borealis%20panoramic%20view&width=1200&height=600&seq=finland-detail-hero-017&orientation=landscape'),
  'polonya': defaultCountryData('Polonya', 'polonya', '🇵🇱', 'Schengen', 'https://readdy.ai/api/search-image?query=krakow%20poland%20main%20square%20historic%20architecture%20colorful%20buildings%20medieval%20city%20wawel%20castle%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=poland-detail-hero-018&orientation=landscape'),
  'cekya': defaultCountryData('Çekya', 'cekya', '🇨🇿', 'Schengen', 'https://readdy.ai/api/search-image?query=prague%20castle%20czech%20republic%20historic%20architecture%20vltava%20river%20charles%20bridge%20panoramic%20view%20tourist%20destination&width=1200&height=600&seq=czech-detail-hero-019&orientation=landscape'),
  'macaristan': defaultCountryData('Macaristan', 'macaristan', '🇭🇺', 'Schengen', 'https://readdy.ai/api/search-image?query=budapest%20parliament%20hungary%20danube%20river%20gothic%20architecture%20illuminated%20night%20view%20chain%20bridge%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=hungary-detail-hero-020&orientation=landscape'),
  'slovakya': defaultCountryData('Slovakya', 'slovakya', '🇸🇰', 'Schengen', 'https://readdy.ai/api/search-image?query=bratislava%20castle%20slovakia%20danube%20river%20historic%20fortress%20panoramic%20city%20view%20old%20town%20tourist%20destination&width=1200&height=600&seq=slovakia-detail-hero-021&orientation=landscape'),
  'slovenya': defaultCountryData('Slovenya', 'slovenya', '🇸🇮', 'Schengen', 'https://readdy.ai/api/search-image?query=lake%20bled%20slovenia%20island%20church%20mountains%20alpine%20scenery%20emerald%20water%20beautiful%20nature%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=slovenia-detail-hero-022&orientation=landscape'),
  'hirvatistan': defaultCountryData('Hırvatistan', 'hirvatistan', '🇭🇷', 'Schengen', 'https://readdy.ai/api/search-image?query=dubrovnik%20croatia%20old%20town%20adriatic%20sea%20medieval%20walls%20orange%20roofs%20coastal%20city%20game%20of%20thrones%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=croatia-detail-hero-023&orientation=landscape'),
  'estonya': defaultCountryData('Estonya', 'estonya', '🇪🇪', 'Schengen', 'https://readdy.ai/api/search-image?query=tallinn%20estonia%20old%20town%20medieval%20architecture%20colorful%20buildings%20baltic%20city%20historic%20walls%20towers%20tourist%20destination%20panoramic%20view&width=1200&height=600&seq=estonia-detail-hero-024&orientation=landscape'),
};

const allCountriesData = { ...countriesData, ...additionalCountries };

export default function CountryDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const country = slug ? allCountriesData[slug] : null;

  if (!country) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <h1 className="font-heading font-bold text-2xl sm:text-3xl text-darkBlue mb-4">Ülke Bulunamadı</h1>
          <Link to="/ulkeler" className="text-secondary hover:underline cursor-pointer">
            Ülkeler sayfasına dön
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-64 sm:h-80 lg:h-96 overflow-hidden">
        <img 
          src={country.image} 
          alt={`${country.name} turistik görsel`}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-darkBlue/90 to-darkBlue/70 flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="flex items-center space-x-3 sm:space-x-4 mb-3 sm:mb-4">
              <span className="text-4xl sm:text-5xl lg:text-6xl">{country.flag}</span>
              <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-white text-xs sm:text-sm font-semibold">
                {country.type}
              </span>
            </div>
            <h1 className="font-heading font-bold text-2xl sm:text-3xl lg:text-5xl text-white mb-2 sm:mb-4">
              {country.name} Vizesi İzmir
            </h1>
            <p className="font-body text-sm sm:text-base lg:text-xl text-white/90 max-w-3xl">
              {country.description}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 sm:py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="font-body text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed mb-6 sm:mb-8">
              {country.visaInfo.intro}
            </p>

            {country.sections.map((section, index) => (
              <div key={index} className="mb-8 sm:mb-12">
                <h2 className="font-heading font-bold text-xl sm:text-2xl text-darkBlue mb-3 sm:mb-4">
                  {section.title}
                </h2>
                <p className="font-body text-sm sm:text-base text-gray-700 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Visa Info Cards */}
      <section className="py-12 sm:py-16 lg:py-20 bg-lightBlue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-darkBlue mb-6 sm:mb-8 text-center">
            {country.name} Vize Bilgileri
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            <div className="bg-white rounded-xl p-5 sm:p-6 shadow-md text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-time-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">İşlem Süresi</h3>
              <p className="font-body text-sm text-gray-600">{country.visaInfo.duration}</p>
            </div>
            <div className="bg-white rounded-xl p-5 sm:p-6 shadow-md text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-money-euro-circle-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">Vize Ücreti</h3>
              <p className="font-body text-sm text-gray-600">{country.visaInfo.fee}</p>
            </div>
            <div className="bg-white rounded-xl p-5 sm:p-6 shadow-md text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-calendar-check-line text-secondary text-xl sm:text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2">Geçerlilik</h3>
              <p className="font-body text-sm text-gray-600">{country.visaInfo.validity}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Requirements Section */}
      <section className="py-12 sm:py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-darkBlue mb-6 sm:mb-8 text-center">
            Gerekli Evraklar
          </h2>
          <div className="bg-lightBlue rounded-2xl p-5 sm:p-6 lg:p-8">
            <ul className="space-y-2 sm:space-y-3">
              {country.visaInfo.requirements.map((req, index) => (
                <li key={index} className="flex items-start space-x-3 font-body text-sm sm:text-base text-gray-700">
                  <i className="ri-checkbox-circle-fill text-secondary mt-0.5 flex-shrink-0"></i>
                  <span>{req}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-lightBlue">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-darkBlue mb-6 sm:mb-8 text-center">
            Başvuru Süreci
          </h2>
          <div className="space-y-3 sm:space-y-4">
            {country.visaInfo.process.map((step, index) => (
              <div key={index} className="bg-white rounded-xl p-4 sm:p-6 flex items-start space-x-3 sm:space-x-4 shadow-md">
                <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-secondary rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-base">
                  {index + 1}
                </div>
                <p className="font-body text-sm sm:text-base text-gray-700 pt-1 sm:pt-2">{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-3xl text-darkBlue mb-6 sm:mb-8 lg:mb-12 text-center">
            Sıkça Sorulan Sorular
          </h2>
          <div className="space-y-4 sm:space-y-6">
            {country.faqs.map((faq, index) => (
              <div key={index} className="bg-lightBlue rounded-xl p-5 sm:p-6">
                <h4 className="font-heading font-bold text-base sm:text-lg text-darkBlue mb-2 sm:mb-3">
                  {faq.question}
                </h4>
                <p className="font-body text-sm sm:text-base text-gray-600">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-r from-secondary to-orange-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-4xl text-white mb-3 sm:mb-4">
            {country.name} Vizesi İçin Hemen Başvurun
          </h2>
          <p className="font-body text-sm sm:text-base lg:text-lg text-white/90 mb-6 sm:mb-8">
            Profesyonel danışmanlık ve %98 başarı oranı ile vize sürecinizi güvenle yönetin
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/iletisim"
              className="bg-white hover:bg-gray-100 text-secondary px-5 sm:px-6 lg:px-8 py-2.5 sm:py-3 lg:py-4 rounded-full font-body font-bold text-sm sm:text-base transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Ücretsiz Danışmanlık
            </Link>
            <a
              href="tel:+905422671171"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border-2 border-white px-5 sm:px-6 lg:px-8 py-2.5 sm:py-3 lg:py-4 rounded-full font-body font-bold text-sm sm:text-base transition-all whitespace-nowrap cursor-pointer"
            >
              +90 542 267 11 71
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
